function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(-2572 -1568)"
}, /*#__PURE__*/React.createElement("g", {
  id: "success1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#success_path0_fill",
  transform: "translate(2572 1568)"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "success_path0_fill",
  d: "M 33.7721 0.188843C 33.6988 0.123481 33.6133 0.0732685 33.5205 0.0410926C 33.4276 0.00891669 33.3294 -0.0045743 33.2313 0.00137399C 33.1333 0.00732228 33.0374 0.0326009 32.9491 0.0757606C 32.8609 0.11892 32.782 0.179106 32.7171 0.252854L 13.1721 22.2348L 1.20314 12.6669C 1.07432 12.5609 0.912919 12.5026 0.746142 12.5018C 0.592211 12.5012 0.441873 12.5484 0.315912 12.6369C 0.189952 12.7253 0.0945852 12.8508 0.0429861 12.9958C -0.00861306 13.1408 -0.0138943 13.2983 0.0278723 13.4464C 0.0696388 13.5946 0.156391 13.7261 0.27614 13.8228L 12.7911 23.8349C 12.9267 23.9377 13.0911 23.9954 13.2611 23.9998C 13.3672 24.001 13.4723 23.9788 13.5689 23.935C 13.6654 23.8911 13.7512 23.8265 13.8201 23.7458L 33.8321 1.23085C 33.9616 1.08438 34.028 0.892669 34.0167 0.697495C 34.0055 0.502321 33.9176 0.319489 33.7721 0.188843Z"
}));

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 -5 35 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5287595d.svg";
export { ForwardRef as ReactComponent };